import { Box, Breadcrumbs, Container, Typography } from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

// components
import ActionFooter from "../../components/ActionFooter";
import FullScreenLoading from "../../components/FullScreenLoading";
import BaseInfo from "../../components/banner/BaseInfo";

// api
import { BannerApi } from "../../api/BannerApi";

export default function Edit() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [fullScreenLoading, setFullScreenLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      title: null,
      link: null,
      media: null,
      alt: null,
      type: null,
    },
    validateOnMount: true,
  });

  useEffect(() => {
    if (!id) {
      navigate(-1);
    }
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setFullScreenLoading(true);
      const response = await BannerApi.details(id);
      if (response) {
        formik.setValues(response);
      }
      setFullScreenLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setFullScreenLoading(false);
    }
  };

  const onSubmit = async () => {
    try {
      if (formik.values.media === null || formik.values.media.length === 0) {
        toast.error(t("error.media_is_required"));
        return;
      }

      setFullScreenLoading(true);

      let input = {
        banner: formik.values,
      };

      const success = await BannerApi.update(id, input);
      if (success) {
        toast.success(t("layout.updated_successfully"));
        fetchData();
      }

      setFullScreenLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setFullScreenLoading(false);
    }
  };

  const onCancel = () => {
    navigate(-1);
  };

  const deleteData = async () => {
    try {
      setFullScreenLoading(true);
      const success = await BannerApi.deleteData(id);
      if (success) {
        toast.success(t("layout.deleted_successfully"));
        navigate("/banner");
      }
      setFullScreenLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setFullScreenLoading(false);
    }
  };

  return (
    <Container maxWidth="false">
      <FullScreenLoading open={fullScreenLoading} />
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
        <Link to={"/banner"}>{t("menu.banner")}</Link>
        <Typography color="text.primary">{t("layout.edit")}</Typography>
      </Breadcrumbs>
      <Box component="form">
        <BaseInfo formik={formik} onDelete={deleteData} />
      </Box>
      <ActionFooter onCancel={onCancel} onSubmit={onSubmit} />
    </Container>
  );
}
